// extracted by mini-css-extract-plugin
module.exports = {"main":"debug-widget_main__OEGkm","phAnimation":"debug-widget_phAnimation__mgVBf"};